















import { Vue, Component } from 'vue-property-decorator'
import { Container, Logo, Box, PositiveSubheader, Button } from '../atoms/'
import { AUTH_MODULE, FORGOT_EMAIL_LOGIN } from '@/store/modules/auth/constant'
import { mapGetters } from 'vuex'
import { APP_MODULE, TRANSLATE } from '@/store/modules/app/constant'

@Component({
  components: {
    Container,
    Logo,
    Box,
    PositiveSubheader,
    Button
  },
  computed: {
    ...mapGetters(AUTH_MODULE, [FORGOT_EMAIL_LOGIN]),
    ...mapGetters(APP_MODULE, [TRANSLATE]),
  },
})
export default class ResetPasswordSuccess extends Vue {
  private email = ''
  mounted() {
    this.email = this.forgotEmail;
  }
  get forgotEmail(): string {
    return (this as any)[FORGOT_EMAIL_LOGIN]
  }
  get channel() {
    return this.$route?.query?.channel
  }
  backToLogin() {
    const baseURL = process.env.VUE_APP_FINNO_ENDPOINT || ''
    location.href = baseURL + '/finno-login'
  }
}
